export default __webpack_public_path__ + "locales/pl/EmptyView.json?hash=7f7a6c180176e1bd0f98afddadf9567f";